import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    switchRoot: {
        '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
                // Когда активен
                '& + .MuiSwitch-track': {
                    backgroundColor: 'transparent !important',
                    border: '1px solid rgba(255, 255, 255, 0.2) !important',  
                    opacity: 1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',  

                },
            },
            '&:not(.Mui-checked)': {
                // Когда не активен
                '& + .MuiSwitch-track': {
                    backgroundColor: 'transparent !important',
                    border: '1px solid #00BA6C !important',  
                    opacity: 1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: '#00BA6C',  
                },
            },
        },
        '& .MuiSwitch-track': {
            borderRadius: 20, 
            boxSizing: 'border-box',  
        },
    },
    label: {
        fontFamily: 'Montserrat',
        fontWeight: 700,
        fontSize: 20,
        color: "rgba(255, 255, 255, 0.2)",
        transition: "color 0.5s ease",
    },
    labelActive: {
        color: "#fff",
    },
    leftLabel: {
        marginRight: "12px",
    },
    rightLabel: {
        marginLeft: "12px",
    },
});
